import { ChevronIcon } from 'components/icons'

const PageLayout = () => {
  return (
    <>
      <div className="flex gap-2 pt-4">
        <ChevronIcon className="block size-5 rotate-180 text-gray-100 md:hidden" />
        <div className="h-5 w-24 bg-gray-100 dark:bg-gray-800" />
        <ChevronIcon className="hidden size-5 text-gray-100 md:block" />
        <div className="hidden h-5 w-18 bg-gray-100 md:block dark:bg-gray-800" />
        <div className="flex-1 md:hidden" />
        <div className="-mt-1 h-8 w-36 rounded-full bg-gray-100 md:hidden dark:bg-gray-800" />
      </div>
      <div className="flex w-full items-center gap-2 pt-6">
        <div className="h-10 w-1/2 bg-gray-100 md:w-1/3 dark:bg-gray-800" />
        <div className="hidden flex-1 md:flex" />
        <div className="hidden h-10 w-48 rounded-full bg-gray-100 md:flex dark:bg-gray-800" />
      </div>
      <div className="pt-12">
        <div className="flex rounded-xl bg-gray-100 p-3 dark:bg-gray-800">
          <div className="flex w-full flex-1 flex-col rounded-lg border border-gray-200 bg-white text-left dark:border-gray-500 dark:bg-gray-600">
            {[...new Array(6)].map((_, index) => (
              <div
                key={index}
                className="flex flex-col border-b border-gray-100 px-4 py-3.5 last-of-type:border-0 sm:flex-row sm:items-center">
                <div className="flex-0 mb-6 flex sm:mb-0 sm:h-full md:items-center">
                  <div className="mr-6 h-18 w-18 rounded-xl bg-gray-100 p-1 ring-2 ring-gray-100 dark:bg-gray-800" />
                </div>
                <div className="flex flex-1 flex-col md:flex-row">
                  <div className="mr-10 w-full sm:w-4/5 md:w-1/2 lg:w-1/3">
                    <div className="mb-2 h-6 w-1/2 bg-gray-100 p-1 dark:bg-gray-800" />
                    <div className="flex flex-col lg:flex-row lg:items-center">
                      <div className="flex w-2/3 items-center lg:w-1/3">
                        <div className="flex-0 mr-2 h-5 w-5 rounded-full bg-gray-100" />
                        <div className="h-4 w-1/3 flex-1 bg-gray-100 p-1 lg:w-full dark:bg-gray-800" />
                      </div>
                    </div>
                  </div>
                  <div className="mt-2 w-full text-sm text-gray-300 sm:w-4/5 md:mt-0 md:w-1/2 lg:w-1/3">
                    <div className="mb-2 flex items-center">
                      <div className="mr-2 h-5 w-5 rounded-full bg-gray-100" />
                      <div className="h-4 w-1/2 bg-gray-100 p-1 dark:bg-gray-800" />
                    </div>
                    <div className="flex items-center">
                      <div className="mr-2 h-5 w-5 rounded-full bg-gray-100" />
                      <div className="h-4 w-1/3 bg-gray-100 p-1 dark:bg-gray-800" />
                    </div>
                  </div>
                </div>
                <div className="flex-0 mr-12 hidden sm:inline-block">
                  <div className="mr-2 h-12 w-12 rounded-full border-8 border-gray-100 bg-transparent" />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  )
}

export default PageLayout
